import type { AssetColors } from '../../palette.js';

const CEDARS = {
  spire: {
    crown:
      'M0,-16 -1.9,-12.1 -.9,-12.4 -3.2,-8.8 -1.9,-9.1 -4.5,-5.2 Q-2.6,-4.5 -1.2,-5 L-4.8,-2.6 Q-2.3,-1.7 0,-2.4 Q2.9,-1.6 4.6,-2.6 L2,-5 4.1,-5.1 1.6,-9 2.9,-8.7 .8,-12.4 1.6,-12.1Z',
    face: 'M0,-16 -1.9,-12.1 -.9,-12.4 -3.2,-8.8 -1.9,-9.1 -4.5,-5.2 Q-2.5,-4.6 -.3,-5.6 L-4.8,-2.6 Q-2.4,-2.1 .1,-3.2 L.5,-6 -.1,-8.5 .5,-11.2Z',
    light:
      'M0,-16 -1.6,-12.4 -.3,-12.9Z M-1,-11.1 -2.6,-9.1 -.4,-9.6Z M-1.7,-7.4 -3.7,-5.5 -.6,-6.2Z M-2.4,-3.7 -4,-2.8 -1,-3.3Z',
  },
  fan: {
    crown:
      'M-.8,-12 -2.8,-9.6 -.9,-9.7 -4.7,-6.9 -2.2,-7.1 -5.4,-3.8 Q-3.1,-2.9 -.6,-3.5 Q2.5,-2.7 5,-3.8 L2.2,-6.4 4,-6.3 .9,-9 2.3,-8.9Z',
    face: 'M-.8,-12 -2.8,-9.6 -.9,-9.7 -4.7,-6.9 -2.2,-7.1 -5.4,-3.8 Q-3.2,-3.3 -.6,-4.1 L.3,-6 -.1,-8Z',
    light: 'M-.8,-12 -2.5,-9.8 -.6,-10.1Z M-1.9,-8.5 -4,-7.1 -.8,-7.7Z M-2.4,-5.7 -4.7,-4 .1,-4.8Z',
  },
  lean: {
    crown:
      'M2,-14.5 -.3,-11.8 .8,-11.9 -2.6,-8.7 -.9,-8.9 -4.1,-5.9 -1.7,-6.1 -5.2,-3.4 Q-2.2,-2.9 .2,-3.8 Q2.8,-3.1 4.7,-4.3 L2.6,-7.1 4.1,-6.9 2.6,-10 3.4,-9.9Z',
    face: 'M2,-14.5 -.3,-11.8 .8,-11.9 -2.6,-8.7 -.9,-8.9 -4.1,-5.9 -1.7,-6.1 -5.2,-3.4 Q-2.4,-3.2 .4,-4.7 L1.1,-7 1.2,-10.2Z',
    light:
      'M2,-14.5 .1,-12 1.4,-12.3Z M.1,-10.5 -1.9,-9 1,-9.8Z M-1.2,-7.5 -3.4,-6.1 .4,-6.9Z M-2.2,-4.7 -4.3,-3.6 -.3,-4.4Z',
  },
} as const;
const GROVES = [
  [
    [-3.9, 0, 0.59, 'fan'],
    [3.4, -0.2, 0.57, 'spire'],
    [0, 0.2, 1, 'spire'],
  ],
  [
    [2.8, -0.7, 0.82, 'spire'],
    [-2, 0.4, 0.9, 'fan'],
  ],
  [
    [-4.1, -0.4, 0.49, 'spire'],
    [3.8, 0.3, 0.47, 'fan'],
    [0, 0.3, 0.95, 'lean'],
  ],
] as const;

export function svgCedarGrove(x: number, y: number, c: AssetColors, v: number): string {
  const grove = GROVES[v] ?? GROVES[0];
  const trees = grove
    .map(([dx, dy, scale, form]) => {
      const tree = CEDARS[form];
      return (
        `<g transform="translate(${dx},${dy}) scale(${scale})">` +
        `<path d="M-1.3,.5 -.55,-.6 -.5,-5.4 .25,-7 .8,-6.8 .35,-4.7 .65,-.5 1.65,.4 .3,.1Z" fill="${c.trunk}"/>` +
        `<path d="M-.4,-.4 -.3,-4.4 .1,-4.5 .15,-.2Z" fill="${c.stump}"/>` +
        `<path d="${tree.crown}" fill="${c.evergreenDark}"/>` +
        `<path d="${tree.face}" fill="${c.pine}"/>` +
        `<path d="${tree.light}" fill="${c.evergreenLight}"/></g>`
      );
    })
    .join('');
  return (
    `<g transform="translate(${x},${y})">` +
    `<ellipse cx="0" cy=".45" rx="6.7" ry="1.1" fill="${c.shadow}" opacity=".13"/>${trees}` +
    `<path d="M-4.2,.2 -4.8,-.3 -4,-.1 -3.7,-1.1 -3.35,-.25 -2.4,-.7 -2.8,.1Z M2,.5 1.4,-.2 2.4,0 2.8,-.9 3.1,-.1 4,-.4 3.7,.45Z" fill="${c.pine}"/></g>`
  );
}
